var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"text-center"},[_c('img',{staticClass:"mt-4",attrs:{"src":require("@/assets/vuejs-color.svg"),"height":"96"}}),_c('p',[_vm._v(_vm._s(_vm.$t('vueblock_edit.title')))]),_c('v-btn',{attrs:{"x-large":"","depressed":"","dark":"","color":"light-green","to":{
      name: 'adminVueBlockEdit',
      params: { componentId: _vm.componentId },
    },"target":"_blank"}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("open_in_new")]),_vm._v(" "+_vm._s(_vm.$t('vueblock_edit.openBtn'))+" ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }